export default {
  en: {
    newTransfer: 'New Transfer',
    transferList: 'Transfer',
    name: 'Name',
    price: 'Price',
    unit: 'Unit',
    minPax: 'Min Pax',
    maxPax: 'Max Pax',
    status: 'Status',
    conditionDetail: 'Condition',
    transferUnitTypeCar: 'Per Car',
    transferUnitTypePerPerson: 'Per Person',
    createTransfer: 'Create Transfer',
    cancel: 'Cancel',
    createTransferSuccessTitle: 'Success',
    createTransferSuccessMessage: 'Create Transfer Success.'
  },
  th: {
    newTransfer: 'สร้างรถรับส่ง',
    transferList: 'รถรับส่ง',
    name: 'ชื่อ',
    price: 'ราคา',
    unit: 'หน่วย',
    minPax: 'จำนวนขั้นต่ำ',
    maxPax: 'จำนวนสูงสุด',
    status: 'สถานะ',
    conditionDetail: 'เงื่อนไขและรายละเอียด',
    transferUnitTypeCar: 'ต่อคัน',
    transferUnitTypePerPerson: 'ต่อคน',
    createTransfer: 'สร้างรถรับส่ง',
    cancel: 'ยกเลิก',
    createTransferSuccessTitle: 'สำเร็จ',
    createTransferSuccessMessage: 'สร้างรถรับส่งสำเร็จ'
  }
}
